
import setting from '../setting.json'
import axios from 'axios'

/** Normalize non-JSON / HTML gateway dumps into a predictable shape */
const normalizePayload = (data) => {
  if (data == null) return { success: false, message: 'Empty response' }
  if (typeof data === 'object') return data
  if (typeof data === 'string') {
    const trimmed = data.trim()
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        return JSON.parse(trimmed)
      } catch (e) { /* fall through */ }
    }
    const msgMatch = trimmed.match(/\[message\]\s*=>\s*(.+)/)
    const codeMatch = trimmed.match(/\[code\]\s*=>\s*(\d+)/)
    return {
      success: false,
      message: (msgMatch && msgMatch[1].trim()) || 'Payment gateway error',
      code: codeMatch ? Number(codeMatch[1]) : undefined,
      raw: trimmed.slice(0, 500)
    }
  }
  return { success: false, message: 'Unexpected response' }
}

const ApiService = async (endpoint, req, method, call = null) => {
  try {
    const config = {
      method: method,
      url: setting?.server + endpoint,
      headers: {
        'cache-control': 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
    }
    if (method.toLowerCase() === 'get') {
      config.params = req || {}
    } else {
      config.data = req || {}
    }
    const response = await axios(config)
    return normalizePayload(response.data)
  } catch (err) {
    console.log(err, 'error')
    if (err?.response?.data != null) {
      const parsed = normalizePayload(err.response.data)
      return {
        success: false,
        ...parsed,
        message: parsed.message || err.message || 'Request failed',
        exception: parsed.exception || err.response.data?.exception,
        status: err.response.status
      }
    }
    return {
      success: false,
      message: err?.message || 'Network error'
    }
  }

}

export default ApiService;
// const ApiService = async (endpoint, req, method, call = null) => {
//   try {
//     const response = await fetch(setting?.server + endpoint, {
//       method: method,
//       headers: {
//         'cache-control': 'no-cache',
//         'Content-Type': 'application/json',
//         'Access-Control-Allow-Origin': '*'
//       },
//       data: JSON.stringify(req || {})
//     });
//     console.log(response, 'response')
//     // return await response.json()
//   } catch (err) {
//     console.log(err, 'error')
//     return err
//   }

// }


